export const PricingCardsData = [
  {
    heading: 'Basic',
    description: 'For businesses that need to record & share quick videos.',
    price: 0,
    features: [
      {
        text: 'Screen + webcam recording',
      },
      {
        text: 'Upto 20 mins recording',
      },
      {
        text: 'Unlimited recordings',
      },
      {
        text: '10 local savings',
      },
      {
        text: 'Folder Creation',
      },
      {
        text: 'Record system + mic audio',
      },
      {
        text: 'Trim',
      },
      {
        text: 'Link creation & share',
        fade: true,
      },
      {
        text: 'Unlimited Cloud backups',
        fade: true,
      }  
    ],
    buttonText: 'Get Started',
  },
  {
    heading: 'STANDARD',
    description: 'For Enterprises that need to record & share quick videos.',
    price: 1.99,
    features: [
      {
        text: 'Screen + webcam recording',
      },
      {
        text: 'Upto 2 hrs recording',
      },
      {
        text: 'Unlimited recordings',
      },
      {
        text: 'Unlimited local savings',
      },
      {
        text: 'Folder Creation',
      },
      {
        text: 'Record system + mic audio',
      },
      {
        text: 'Instant editing',
      },
      {
        text: 'Link creation & share',
        // faded: true,
      },
      {
        text: 'Upto 10 Cloud backups',
        bold: true,
      }  
    ],
    buttonText: 'Get Started',
  },
  {
    heading: 'PREMIUM',
    description: 'Integrate Screenapp to your website',
    price: 4.99,
    features: [
      {
        text: 'Screen + webcam recording',
      },
      {
        text: 'Upto 3 hrs recording',
      },
      {
        text: 'Unlimited recordings',
      },
      {
        text: 'Unlimited local savings',
      },
      {
        text: 'Folder Creation',
      },
      {
        text: 'Record system + mic audio',
      },
      {
        text: 'Instant editing',
      },
      {
        text: 'Link creation & share',
      },
      {
        text: 'Unlimited Cloud backups',
        bold: true,
      }  
    ],
    buttonText: 'Coming soon',
    red: true,
  },
];
